export enum FeaturesTypePathEnum {
  HOME = "home",
  HOTELS = "hotels",
  FLIGHTS = "flights",
  EXPERIENCE = "experience",
  CARRENTALS = "car-rentals",
  TOURS = "tour-packages",
  BUSINESS = "business-travel",
  CONTACT = "contact-us",
  TERMS = "terms-and-conditions",
  POLICY = "privacy-policy",
  AIRLINES = "airlines",
  ABOUTUS = "about-us",
  PARTNERSHIP = "partnership",
  FAQS = "faqs",
  NEWSROOM = "news-room",
  PROMOTIONS = "promotions",
  HOWTOBOOK = "how-to-book",
  TRAVELSTORIES = "travel-stories",
  KLUB = "klub",
  KLUBSTORIES = "klub-stories",
  EXPERIENCES = "experiences",
  ACCOUNT = "account",
  // TICKET = "tickets",
  // INSURANCE = "insurance",
  // TRANSFERS = "airport-transfers",
}

export enum FeaturesTypePathMainEnum {
  HOTELS = FeaturesTypePathEnum.HOTELS,
  FLIGHTS = FeaturesTypePathEnum.FLIGHTS,
  EXPERIENCE = FeaturesTypePathEnum.EXPERIENCES,
  CARRENTALS = FeaturesTypePathEnum.CARRENTALS,
  KLUB = FeaturesTypePathEnum.KLUB,
  TOUR = FeaturesTypePathEnum.TOURS,
}

export enum ProductTypeEnum {
  HOTEL = "hotel",
  FLIGHT = "flight",
  EXPERIENCE = "experience",
  EVENT_EXPERIENCE = "event",
  CAR_RENTALS = "car-rentals",
  TOURS = "tour-packages",
}
export enum ApiExp {
  EXPLANDINGPAGE = "landingPage=experience",
  EXPPRODUCT = "product=experience",
}

export enum CountryPathEnum {
  THAILAND = "thailand",
}

export enum CityPathEnum {
  BANGKOK = "bangkok",
  SAMUTSONGKHRAM = "samut-songkhram",
}

export enum GotherSideEnum {
  CLIENT = "web-client",
  SERVER = "web-server",
  MIDDLEWERE = "web-middlewere",
}
